import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * GA4 SPA page-view tracker.
 *
 * The gtag script in public/index.html is configured with
 * `send_page_view: false`, so GA4 never fires page_view automatically.
 * This component fires exactly one `page_view` event on every route
 * change — including the initial mount — so we get accurate SPA
 * analytics without any duplicate events on hydration or navigation.
 */
export default function GA4Tracker() {
    const { pathname, search } = useLocation();

    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
        const page_path = pathname + search;
        window.gtag('event', 'page_view', {
            page_path,
            page_location: window.location.href,
            page_title: document.title,
        });
    }, [pathname, search]);

    return null;
}
